//import React from 'react';
//import PropTypes from 'prop-types';

const CONTACT_EMAIL_MASK = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/i;
const CONTACT_PHONE_MASK = /^\+?([87](?!95[5-7]|998|907|94[^09]|336)([348]\d|9[0-6789]|7[01247])\d{8}|[1246]\d{9,13}|68\d{7}|5[1-46-9]\d{8,12}|55[1-9]\d{9}|55[138]\d{10}|55[1256][14679]9\d{8}|554399\d{7}|500[56]\d{4}|5016\d{6}|5068\d{7}|502[345]\d{7}|5037\d{7}|50[4567]\d{8}|50855\d{4}|509[34]\d{7}|376\d{6}|855\d{8,9}|856\d{10}|85[0-4789]\d{8,10}|8[68]\d{10,11}|8[14]\d{10}|82\d{9,10}|852\d{8}|90\d{10}|96(0[79]|17[0189]|181|13)\d{6}|96[23]\d{9}|964\d{10}|96(5[569]|89)\d{7}|96(65|77)\d{8}|92[023]\d{9}|91[1879]\d{9}|9[34]7\d{8}|959\d{7,9}|989\d{9}|971\d{8,9}|97[02-9]\d{7,11}|99[^4568]\d{7,11}|994\d{9}|995[57]\d{8}|996[2579]\d{8}|998[235789]\d{8}|380[345679]\d{8}|381\d{9}|38[57]\d{8,9}|375[234]\d{8}|372\d{7,8}|37[0-4]\d{8}|37[6-9]\d{7,11}|30[69]\d{9}|34[679]\d{8}|3459\d{11}|316\d{8}|324\d{8}|33[67]\d{8}|35\d{8,12}|36\d{9}|39\d{8,10}|38[169]\d{8}|382\d{8,9}|46719\d{10})$/;

const CONTACT_FIELDS_DATA = [
  {
    title: 'contacts',

    fields: [
      [
        {
          name: 'lastname',
          path: 'recipient',
          methods: ['pickup', 'courier', 'mail'],
          props: { required: true, label: 'lastname' },
          validate: (value) => {
            if (value.length > 500) return { note: 'value.long', error: true };

            if (value.length > 1) return null;

            return { note: 'lastname.enter', error: true };
          }
        },

        {
          name: 'firstname',
          path: 'recipient',
          methods: ['pickup', 'courier', 'mail'],
          props: { required: true, label: 'firstname' },
          validate: (value) => {
            if (value.length > 500) return { note: 'value.long', error: true };

            if (value.length > 1) return null;

            return { note: 'firstname.enter', error: true };
          }
        }
      ],

      [
        {
          name: 'patronymic',
          path: 'recipient',
          methods: ['pickup', 'courier', 'mail'],
          props: { label: 'patronymic' },
          validate: (value) => {
            if (value.length > 500) return { note: 'value.long', error: true };

            if (!value.length || value.length > 1) return null;

            return { note: 'patronymic.enter', error: true };
          }
        },

        {
          name: 'email',
          path: 'recipient',
          methods: ['pickup', 'courier', 'mail'],
          props: { required: true, label: 'email' },
          validate: (value) => {
            if (!value.length) return { note: 'value.empty', error: true };

            if (value.length > 50) return { note: 'value.long', error: true };

            if (CONTACT_EMAIL_MASK.test(value)) return null;

            return { note: 'email.bad', error: true };
          }
        }
      ],

      [
        {
          name: 'phone',
          path: 'recipient',
          methods: ['pickup', 'courier', 'mail'],
          props: { required: true, label: 'phone.mobile' },
          validate: (value) => {
            if (!value.length) return { note: 'value.empty', error: true };

            if (value.length > 20) return { note: 'value.long', error: true };

            if (CONTACT_PHONE_MASK.test(value.replace(/\D/g, ''))) return null;

            return { note: 'phone.bad', error: true };
          }
        },

        {
          name: 'phone2',
          path: 'recipient',
          methods: ['pickup', 'courier', 'mail'],
          props: { label: 'phone2' },
          validate: (value) => {
            if (!value.length) return null;

            if (value.length > 20) return { note: 'value.long', error: true };

            if (CONTACT_PHONE_MASK.test(value.replace(/\D/g, ''))) return null;

            return { note: 'phone.bad', error: true };
          }
        }
      ],

      [
        {
          name: 'note',
          path: '',
          methods: ['pickup', 'mail'],
          props: { multiline: true, label: 'comments' },
          validate: (value) => {
            return { note: value.length + '/200', error: value.length > 200 };
          }
        }
      ]
    ]
  },

  {
    title: 'delivery.address',

    fields: [
      [
        {
          name: 'street',
          path: 'address',
          methods: ['courier', 'mail'],
          props: { required: true, label: 'street' },
          validate: (value) => {
            if (value.length > 200) return { note: 'value.long', error: true };

            return !value.length ? { note: 'value.empty', error: true } : null;
          }
        }
      ],

      [
        {
          name: 'house',
          path: 'address',
          methods: ['courier', 'mail'],
          props: { required: true, label: 'house' },
          validate: (value) => {
            if (value.length > 20) return { note: 'value.long', error: true };

            return !value.length ? { note: 'value.empty', error: true } : null;
          }
        },

        {
          name: 'bulk',
          path: 'address',
          methods: ['courier', 'mail'],
          props: { label: 'bulk' },
          validate: (value) => {
            if (value.length > 20) return { note: 'value.long', error: true };

            return null;
          }
        },

        {
          name: 'flat',
          path: 'address',
          methods: ['courier', 'mail'],
          props: { label: 'flat' },
          validate: (value) => {
            if (value.length > 20) return { note: 'value.long', error: true };

            return null;
          }
        }
      ],

      [
        {
          name: 'zip',
          path: 'address',
          methods: ['mail'],
          props: { required: true, label: 'zip' },
          validate: (value) => {
            if (value.length > 20) return { note: 'value.long', error: true };

            return !value.length ? { note: 'value.empty', error: true } : null;
          }
        }
      ],

      [
        {
          name: 'note',
          path: '',
          methods: ['courier'],
          props: { multiline: true, label: 'comments' },
          validate: (value) => {
            return { note: value.length + '/200', error: value.length > 200 };
          }
        }
      ]
    ]
  }
];

export const CONTACT_FIELDS_MAP = CONTACT_FIELDS_DATA.reduce(
  (result, data_item) => {
    data_item.fields.forEach((field_list) =>
      field_list.forEach((field_item) => (result[field_item.name] = field_item))
    );
    return result;
  },
  {}
);

export const getContactFieldData = (method, company) =>
  method && company
    ? CONTACT_FIELDS_DATA.map((data_item) => ({
        ...data_item,
        fields: data_item.fields
          .map((field_list) =>
            field_list.filter(
              (field_item) =>
                field_item.methods.indexOf(method?.code) >= 0 ||
                company.required?.indexOf(
                  method.code + '-' + field_item.name
                ) >= 0
            )
          )
          .filter((field_list) => field_list.length)
      })).filter((data_item) => data_item.fields.length)
    : [];

export const getContactFieldList = (method, company) =>
  getContactFieldData(method, company).flatMap((data_item) =>
    data_item.fields.flatMap((field_list) => field_list)
  );
